export enum DocumentType {
  GOV_ID = 'gov_id',
  CO_OWNER_ID = 'co_owner_id',
  DEED = 'deed',
  APPRAISAL = 'appraisal',
  HOME_INSURANCE = 'home_insurance',
  TAX_RETURN = 'tax_return',
  MORTGAGE_STATEMENT = 'mortgage_statement',
  PHOTO = 'photo',
  OTHER = 'other',
}

type DocumentFieldName =
  | 'governmentId'
  | 'appraisalReport'
  | 'homeInsurance'
  | 'taxReturn'
  | 'mortgageStatement'
  | 'titleDeed'
  | 'coOwnerId'
  | 'propertyPhotos'
  | 'otherDocuments';

export const DOCUMENT_TYPE_CONFIG: Record<
  DocumentType,
  {
    label: string;
    description: string;
    required: boolean;
    accept: string;
    formField: DocumentFieldName;
  }
> = {
  [DocumentType.GOV_ID]: {
    label: 'Government-issued ID',
    description: 'Upload a valid government ID. Required for verification.',
    required: true,
    accept: 'image/*,.pdf',
    formField: 'governmentId',
  },
  [DocumentType.CO_OWNER_ID]: {
    label: 'Co-owner ID',
    description: 'Upload a valid government ID for the co-owner',
    required: false,
    accept: 'image/*,.pdf',
    formField: 'coOwnerId',
  },
  [DocumentType.APPRAISAL]: {
    label: 'Appraisal Report',
    description: 'This document validates the value of declared asset.',
    required: false,
    accept: 'application/pdf,.pdf',
    formField: 'appraisalReport',
  },
  [DocumentType.HOME_INSURANCE]: {
    label: 'Home Insurance',
    description: 'Confirms active home insurance coverage for the property.',
    required: false,
    accept: 'application/pdf,.pdf',
    formField: 'homeInsurance',
  },
  [DocumentType.TAX_RETURN]: {
    label: 'Recent Tax Return',
    description: 'To validate your financial profile and repayment capacity.',
    required: false,
    accept: 'application/pdf,.pdf',
    formField: 'taxReturn',
  },
  [DocumentType.MORTGAGE_STATEMENT]: {
    label: 'Mortgage Statement',
    description: 'Verifies existing mortgage details associated with the property.',
    required: false,
    accept: 'application/pdf,.pdf',
    formField: 'mortgageStatement',
  },
  [DocumentType.DEED]: {
    label: 'Grant or Title Deed',
    description: 'Shows legal ownership of the property.',
    required: true,
    accept: 'application/pdf,.pdf',
    formField: 'titleDeed',
  },
  [DocumentType.PHOTO]: {
    label: 'Property Photo',
    description: 'Clear photos (2-10) of the property improve trust and funding chances.',
    required: false,
    accept: 'image/*',
    formField: 'propertyPhotos',
  },
  [DocumentType.OTHER]: {
    label: 'Additional Document',
    description: 'Additional Document',
    required: false,
    accept: 'image/*,.pdf',
    formField: 'otherDocuments',
  },
};
